export const environment = {
  production: true,
  showTestMessage: false,
  baseUrl: '/GoDocuMngApi'   //  baseUrl: 'http://docu.matar.co.il/GoDocuMngApi'
};



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/environments/environment.ts